import React, { useState } from "react";
import axios from "axios";
import "./StatusApproval.css";
import { API_BASE } from "../../../ApiUrl";

const StatusApproval = ({ applicationId, onSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);

  const tenantUser = JSON.parse(localStorage.getItem("tenant_user"));
  const reviewedBy = tenantUser?.tenant_id;

  const openModal = (type) => {
    setActionType(type);
    setReason("");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Shared API call
  const submitStatus = async (status, reasonText) => {
    await axios.post(
      `${API_BASE}/registration-applications/${applicationId}/stage1_approval/`,
      {
        app_status: status,
        reviewed_by: reviewedBy,
        reason: reasonText || "",
      }
    );
  };

  // Approve: no modal, no reason needed — submits immediately
  const handleApprove = async () => {
    try {
      setApproveLoading(true);
      await submitStatus("APPROVED", "");
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setApproveLoading(false);
    }
  };

  // Return / Reject: still go through modal + reason
  const handleSubmit = async () => {
    if (!reason.trim()) {
      alert("Please enter reason");
      return;
    }

    try {
      setLoading(true);
      await submitStatus(actionType, reason);
      setShowModal(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="status-actions">
        <button
          className="btn approve"
          onClick={handleApprove}
          disabled={approveLoading}
        >
          {approveLoading ? "Approving..." : "Approve"}
        </button>

        <button className="btn return" onClick={() => openModal("RETURNED")}>
          Return
        </button>

        <button className="btn reject" onClick={() => openModal("REJECTED")}>
          Reject
        </button>
      </div>

      {/* MODAL - only for Return / Reject */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>{actionType} Application</h3>

            <textarea
              placeholder="Enter reason..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />

            <div className="modal-actions">
              <button className="btn cancel" onClick={closeModal}>
                Cancel
              </button>

              <button className="btn submit" onClick={handleSubmit}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusApproval;